/*
 * Accessibilità dei caroselli Slick (WCAG 4.1.2, 1.3.1).
 *
 * La versione di Slick inclusa in vendor.js genera ARIA non valido (listbox/option sulle slide,
 * tablist sugli indicatori con figli "presentation", aria-controls verso id inesistenti).
 * Qui si interviene in un punto solo, valido per tutti i caroselli del tema:
 * - l'opzione `accessibility` viene disattivata di default, così Slick non scrive quei ruoli;
 * - dopo init e a ogni cambio slide `slickA11y` sistema frecce, indicatori e ordine di tabulazione.
 */
(function ($) {
    if (!$ || !$.fn || !$.fn.slick) return;

    const strings = window.slickA11yStrings || {};
    const FOCUSABLE = 'a[href], button, input, select, textarea, iframe, video[controls], [tabindex]';
    const EVENTS = 'init.slickA11y reInit.slickA11y afterChange.slickA11y breakpoint.slickA11y';

    function syncSlides(slick) {
        slick.$slideTrack.removeAttr('role');

        slick.$slideTrack.children('.slick-slide').each(function () {
            const hidden = this.getAttribute('aria-hidden') === 'true';

            this.removeAttribute('role');
            this.removeAttribute('aria-describedby');

            // Le slide non visibili restano nel DOM: i loro controlli escono dall'ordine di tabulazione
            // e ci rientrano, con il tabindex originale, quando la slide torna visibile
            $(this).find(FOCUSABLE).each(function () {
                if (hidden) {
                    if (!this.hasAttribute('data-slick-tabindex')) {
                        this.setAttribute('data-slick-tabindex', this.getAttribute('tabindex') || '');
                    }
                    this.setAttribute('tabindex', '-1');
                } else if (this.hasAttribute('data-slick-tabindex')) {
                    const original = this.getAttribute('data-slick-tabindex');

                    if (original === '') {
                        this.removeAttribute('tabindex');
                    } else {
                        this.setAttribute('tabindex', original);
                    }
                    this.removeAttribute('data-slick-tabindex');
                }
            });
        });
    }

    function syncDots(slick) {
        if (!slick.$dots) return;

        slick.$dots.removeAttr('role');
        slick.$dots.closest('div[role="toolbar"]').removeAttr('role');

        slick.$dots.children('li').each(function (index) {
            const button = this.querySelector('button');

            this.removeAttribute('role');
            this.removeAttribute('aria-selected');
            this.removeAttribute('aria-controls');
            this.removeAttribute('aria-hidden');

            if (!button) return;

            button.removeAttribute('role');
            button.removeAttribute('tabindex');
            if (strings.goToSlide) button.setAttribute('aria-label', strings.goToSlide.replace('[number]', index + 1));

            if (this.classList.contains('slick-active')) {
                button.setAttribute('aria-current', 'true');
            } else {
                button.removeAttribute('aria-current');
            }
        });
    }

    function syncArrows(slick) {
        [[slick.$prevArrow, strings.previous], [slick.$nextArrow, strings.next]].forEach(function (arrow) {
            const $arrow = arrow[0];

            if (!$arrow || !$arrow.length) return;

            $arrow.removeAttr('role');
            if (arrow[1] && $arrow.is('button, a')) $arrow.attr('aria-label', arrow[1]);
            $arrow.find('svg').removeAttr('role').attr({ 'aria-hidden': 'true', focusable: 'false' });
        });
    }

    function slickA11y(event, slick) {
        // Gli eventi di un carosello annidato risalgono fino a quello esterno: si ignora il passaggio
        if (!slick || !slick.$slider || event.target !== slick.$slider[0]) return;

        syncSlides(slick);
        syncDots(slick);
        syncArrows(slick);
    }

    const slickPlugin = $.fn.slick;

    $.fn.slick = function () {
        const args = Array.prototype.slice.call(arguments);

        if (typeof args[0] === 'object' || typeof args[0] === 'undefined') {
            args[0] = $.extend({ accessibility: false }, args[0]);

            this.off('.slickA11y')
                .on(EVENTS, slickA11y)
                // Slick aggiorna classi e aria-hidden subito dopo beforeChange, prima dell'animazione
                .on('beforeChange.slickA11y', function (event, slick) {
                    setTimeout(function () { slickA11y(event, slick); }, 0);
                });
        }

        return slickPlugin.apply(this, args);
    };
})(window.jQuery);
